<template>
  <div class="bg-white fluid-container position-fixed-top border rounded shadow p-lg-4 col-lg-5">
    <table class="table">
        <thead class="thead-light ">
            <tr>
                <th width="20%">Username</th>
                <th width="20%">Performance ID</th>
                <th width="10%">Enable</th>
                <th width="15%">Admin</th>
                <th width="10%"></th>
            </tr>
        </thead>
    </table>
        <div v-for="user in users" :key="user.id">
            <userEdit v-if="show" :user="user" @refresh="refresh"></userEdit>
        </div>
   <b-button v-on:click="cancel" variant="primary" class="ml-2">Close</b-button>
  </div>
</template>

<script>
import userEdit from '../components/useredit.vue'
/* eslint-disable */ 
  export default {
    name: "editUsers",
    components: { 
        userEdit
    },
    data() {
      return {
        users: [],
        show: true,
      }
    },
    methods: {
    listUsers() {
        let currentObj = this;
        let params = new URLSearchParams();
        params.append('task', 'listUsers');
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    //console.log(response.data)
                    currentObj.users = response.data
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
      cancel(evt) {
          this.$emit('menuItem', false)
      },
      refresh() {

        this.show = false;
        this.listUsers();
        this.show = true;
      }

    },
    mounted() {
        this.listUsers()
    }
   
  }
</script>
<style scoped>
.fluid-container {
    margin:0 auto 0;
     margin-top: 110px;


}
</style>